import "../../../styles/menu.scss";

import React from "react";
import moment from "moment";

class CurrentTime extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            minute: -1
        };

        this.checkTime = this.checkTime.bind(this);
    }
    componentDidMount() {
        this.interval = setInterval(this.checkTime, 1000);
    }
    componentWillUnmount() {
        clearInterval(this.interval);
    }
    checkTime() {
        const date = new Date;
        const minute = date.getMinutes();
        if( this.state.minute!=minute){
            this.setState({minute:minute});
        }
    }
    render(){
        const time = moment().format("HH:mm");
        const date = moment().format("MMMM DD");
        return (
            <div className="current-time">
                <div className={"clock"} >
                    {time}
                </div>
                <div className={"date"} >
                    {date}
                </div>
            </div>
        );
    }
}
CurrentTime.propTypes = {
};

export default CurrentTime;